import React, { useContext } from 'react';
import { auth, ConfigContext } from '../../../base-ui/lib';
import { ActionButtons } from '../ActionButtons';
import { useApi } from '../../../hooks/useApi';
import { Modal } from '../Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Box, SvgIcon } from '@mui/material';

interface LogoutConfirmModalProps {
	modalOpen: boolean;
	setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
	modalOpen,
	setModalOpen,
}) => {
	const { config } = useContext<any>(ConfigContext);
	const api = useApi();

	return (
		<Modal
			open={modalOpen}
			onClose={() => setModalOpen(false)}
			modalBody={
				<Stack direction="column" alignItems="center">
					<SvgIcon sx={{ mb: 3 }}>
						<svg width="34" height="37" viewBox="0 0 34 37" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M17 0C26.5 0 34 7.5 34 17C34 26.5 26.5 34 17 34C7.5 34 0 26.5 0 17C0 7.5 7.5 0 17 0ZM17 6C15.8954 6 15 6.89543 15 8V18C15 19.1046 15.8954 20 17 20C18.1046 20 19 19.1046 19 18V8C19 6.89543 18.1046 6 17 6ZM17 24C18.1046 24 19 24.8954 19 26C19 27.1046 18.1046 28 17 28C15.8954 28 15 27.1046 15 26C15 24.8954 15.8954 24 17 24Z" fill="#1976D2"/>
						</svg>
					</SvgIcon>
					<Typography variant="h2" fontWeight="bold">
						Logout Confirmation
					</Typography>
					<Box sx={{ width: '80%', textAlign: 'center', mb: 2 }}>
						<Typography variant="sm" color="text.secondary" align="center">
							Are you sure you want to log out?
						</Typography>
					</Box>
				</Stack>
			}
			modalFooter={
				<ActionButtons
					confirmButtonStyle="success"
					confirmButtonText="Logout"
					confirmCallback={async () => {
						if (config.authType === 'cognito') {
							await api.cognito.logout();
							window.location.href = config.logoutUrl;
						} else {
							auth.logout();
							window.location.href = '/';
						}
					}}
					cancelCallback={() => setModalOpen(false)}
				/>
			}
		/>
	);
};
